import { render } from "./Framework.vue?vue&type=template&id=4a6abb0a&scoped=true"
import script from "./Framework.vue?vue&type=script&lang=js"
export * from "./Framework.vue?vue&type=script&lang=js"

import "./Framework.vue?vue&type=style&index=0&id=4a6abb0a&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6abb0a"]])

export default __exports__